<div sxWidth="full" sxHeight="fit" sxBorderColor="one" sxBorderWidth="1px" sxCol sxGap="10px" sxRadius="medium"
  sxPadding="large" sxBackground="light">

  <div sxRow sxGap="15px" sxAlign="center" sxPadding="0 10px">
    <ion-icon sxMargin="10px 0 0" sxTextSize="50px" name="key-outline"></ion-icon>
    <h1 sxTextAlign="left" sxMargin="10px 0 10px">Set Up PIN</h1>
  </div>

  <p sxMargin="5px 10px 18px" sxTextAlign="left" sxColor="two" sxTextSize="small"><span sxTextStyle="italic">qid</span>
    ensures your data remains private and secure. Set up a
    6-digit PIN to enable complete end-to-end encryption.</p>

  <div sxCol sxGap="10px">
    <div class="pin-input-wrapper">
      <p>Enter PIN</p>
      <input [(ngModel)]="inputPassword" class="pin-input" type="password" inputmode="numeric" pattern="[0-9]*"
        maxlength="6">
    </div>

    <div class="pin-input-wrapper">
      <p>Confirm PIN</p>
      <input [(ngModel)]="inputConfirmPassword" class="pin-input" type="password" inputmode="numeric" pattern="[0-9]*"
        maxlength="6">
    </div>
  </div>

  <div sxRow sxGap="15px" sxMargin="20px 0 20px" sxBorderWidth="1px" sxBorderColor="one" sxPadding="medium"
    sxRadius="medium">

    <div sxAlign="center" sxJustify="center" sxCircle="60px" sxBackground="base-shade" sxCenterize="col">
      <ion-icon name="refresh-outline" sxColor="three" sxTextSize="30px"></ion-icon>
    </div>

    <div sxCol sxGap="10px">
      <h1 sxTextSize="medium" sxMargin="0" sxPadding="0" sxColor="two">Do you want to setup a recovery pin?</h1>
      <p sxTextSize="small" sxColor="two" sxMargin="0">Setting up a recovery pin allows you to recover your account
        in case you
        forget your
        primary pin</p>
      <ion-segment [(ngModel)]="setupRecoveryPin" sxWidth="140px" mode="ios">
        <ion-segment-button [value]="true">Yes</ion-segment-button>
        <ion-segment-button [value]="false">No</ion-segment-button>
      </ion-segment>

      @if (setupRecoveryPin == false) {
      <p sxColor="warning" sxTextSize="small" sxMargin="0">Warning: If you forget your
        PIN, you will lose access to your account data.</p>
      }

      @if (setupRecoveryPin == true && authenticatedUser$ | async; as user) {
      <div sxRow sxAlign="center" sxDistribution="start" sxGap="10px" sxBorderWidth="1px 0 0" sxBorderColor="one"
        sxPadding="10px 0 0">
        <ion-icon sxColor="two" sxTextSize="22px" name="mail-outline"></ion-icon>
        <p sxMargin="0" sxTextSize="small" sxColor="success">We will send a recovery PIN to your email {{user.email}}
        </p>
      </div>
      }

    </div>

  </div>
  <super-button iconEnd="arrow-forward-outline" sxMargin="0 0 20px" [showError]="true"
    [action]="onPinConformed">Continue</super-button>

</div>